import { Controller } from "@hotwired/stimulus"

import TomSelect from "tom-select"

// Connects to data-controller="tom-select"
export default class extends Controller {
  connect() {

    this.element.querySelectorAll('.tom-select-icons').forEach((el) => {
      if (!el.tomselect) {
        let settings = {
          sortField: {
            field: "text",
            direction: "asc"
          },
          plugins: ['clear_button'],
          onItemAdd: function () {
            this.setTextboxValue('');
            this.refreshOptions();
          },
          render: {
            item: function (data, escape) {
              return '<div>' +
                '<i class="' + escape(data.value) + ' me-2"></i>' + escape(data.value) +
                '</div>'
            },
            option: function (data, escape) {
              return '<div>' +
                '<i class="' + escape(data.value) + ' me-2"></i>' + escape(data.value) +
                '</div>'
            },
            no_results: function (data, escape) {
              return '<div class="no-results">Não encontrado</div>'
            }
          }
        }
        new TomSelect(el, settings)
      }
    })
    this.element.querySelectorAll('.tom-select-tags').forEach((el) => {
      if (!el.tomselect) {
        let settings = {
          plugins: ['remove_button'],
          create: true,
          onItemAdd: function () {
            this.setTextboxValue('')
            this.refreshOptions()
          },
          render: {
            option: function (data, escape) {
              return '<div class="d-flex"><span>' + escape(data.value) + '</span></div>'
            },
            item: function (data, escape) {
              return '<div>' + escape(data.value) + '</div>'
            },
            no_results: function (data, escape) {
              return '<div class="no-results">Não encontrado</div>'
            }
          }
        }
        new TomSelect(el, settings)
      }
    })
    const elements = this.element.tagName == "SELECT" ? [this.element] : this.element.querySelectorAll('.tom-select')
    let plugins = {}
    elements.forEach((el) => {
      if (!el.tomselect) {
        if (el.multiple) {
          plugins = { remove_button: { title: 'Remover' } }
        } else {
          plugins = { clear_button: { title: 'Limpar' } }
        }
        let settings = {
          itemClass: `item ${el.dataset.itemClass}`,
          plugins: plugins
        }
        new TomSelect(el, settings)
      }
    })
  }
}
